import type {
	API_ListCustomerFutureSessionsResponse,
	API_ListScheduleSessionAttendanceResponse,
	CustomerAttendance,
	PaginationRequest,
} from "@pilatestime/shared-types";
import { queryOptions } from "@tanstack/react-query";
import api from "./api_client";

// API functions
export const fetchAttendanceBySession = (
	token: string,
	organizationId: string,
	sessionId: string,
) =>
	api
		.get<API_ListScheduleSessionAttendanceResponse>(
			`/organizations/${organizationId}/schedule-sessions/${sessionId}/schedule-session-attendance`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		)
		.then((res) => res.data);

// Fetch customer future sessions with pagination
export const fetchCustomerFutureSessions = (
	token: string,
	organizationId: string,
	customerId: string,
	pagination: PaginationRequest,
): Promise<API_ListCustomerFutureSessionsResponse> =>
	api
		.get<API_ListCustomerFutureSessionsResponse>(
			`/organizations/${organizationId}/customers/${customerId}/future-sessions`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
				params: pagination,
			},
		)
		.then((res) => res.data);

// Query options
export const fetchAttendanceBySessionQueryOptions = (
	token: string,
	organizationId: string,
	sessionId: string,
	userId: string,
) =>
	queryOptions({
		queryKey: [
			"attendance",
			"list",
			"bySession",
			organizationId,
			sessionId,
			userId,
		],
		queryFn: (): Promise<CustomerAttendance[]> =>
			fetchAttendanceBySession(token, organizationId, sessionId).then(
				(response) => response.attendances,
			),
		enabled: !!token && !!organizationId && !!sessionId && !!userId,
		staleTime: 2 * 60 * 1000, // 2 minutes
	});

// Query options for customer future sessions
export const fetchCustomerFutureSessionsQueryOptions = (
	userId: string,
	token: string,
	organizationId: string,
	customerId: string,
	pagination: PaginationRequest,
) =>
	queryOptions({
		queryKey: [
			"customer_future_sessions",
			organizationId,
			customerId,
			userId,
			pagination,
		],
		queryFn: () =>
			fetchCustomerFutureSessions(
				token,
				organizationId,
				customerId,
				pagination,
			),
		enabled: !!token && !!organizationId && !!customerId && !!userId,
		staleTime: 2 * 60 * 1000, // 2 minutes
	});
